import { type ConfluenceComment } from '@canvas/atlassian-service/confluence/types';

import { type CommentModel } from '../model';

/**
 * NOTE: For our purposes in whiteboards, we will never have comments which
 * infinitely nest within one another. We make use of inline comments with depth of 1.
 */
export const commentFromConfluenceComment = (
  comment: ConfluenceComment,
  threadId: string,
  type: 'root' | 'reply'
): CommentModel => ({
  id: comment.id,
  reactionsId: comment.reactionsId,
  createdAt: comment.createdAtNonLocalized,
  threadId,
  type,
  author: comment.author,
  body: comment.body,
  version: comment.version,
  reactions: [],
  permissions: comment.permissions,
  replies: (comment.replies ?? [])?.map((reply) =>
    commentFromConfluenceComment(reply, threadId, 'reply')
  ),
  resolved: comment.location.inlineResolveProperties.resolved,
});
